import { render, staticRenderFns } from "./yueShouRu.vue?vue&type=template&id=0dad2808&scoped=true&"
import script from "./yueShouRu.vue?vue&type=script&lang=js&"
export * from "./yueShouRu.vue?vue&type=script&lang=js&"
import style0 from "./yueShouRu.vue?vue&type=style&index=0&id=0dad2808&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dad2808",
  null
  
)

export default component.exports